import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Renderer.SoraCame = function () {
  /*
        データ管理部
    */
  var image_generation = 30; // 各地点あたりの画像保持件数
  var time; // 処理時間
  var epoch = new WRAP.Core.DateTime("19700101"); // timeの基準となる Epoch Date
  var conf = {
    // コンフィグ 下記デフォルト数値は、データ・コンフィグ の値が大きい場合はオーバーライドされる
    max_window: 10, // 同時に開くことができる最大ウィンドウ数
    animation_time_range: 1000, // アニメーション時の最過去時間範囲（秒）
    download_max: 8, // 最大同時データ取得数（並列数）
    image_data_limit: 32000000, // 最大イメージデータサイズ管理数
    image_time_range: 600, // マウスオーバーで表示される過去画像の最大許容レンジ（秒）
    min_request_interval: 0, // 最小データ取得間隔（ミリ秒）
    request_timeout: 60, // データリクエストのタイムアウト時間（秒）
    update_interval: 60, // 最新画像の自動更新間隔（秒）
  };
  var camera_info = {}; // カメラ地点管理情報
  /*
    updated          更新フラグ   カメラ地点情報の取得時間（初期値:0、リクエスト中は MAX_VALUEがセットされる）
    controller       本地点を管理する コンフィグに紐づくデータコント ローラオブジェクト
    path             URL中のディレクトリ名
    name             地点名の表示タイプ (LNAME、ENAMEまたは個別名)

    AREA             カメラ地点コード
    ENAME            地点名称 - 英語
    LNAME            地点名称 - 現地語
    STATUS           運用状況
    TZ               設置場所のタイムゾーン
    JPSCSN           日本の市区町村番号
    lat              設置場所緯度
    lon              設置場所経度
    dir              撮影方向 [16方位→360度変換]

    visible          カメラ画像範囲の可視状態
    expanded         カメラ画像拡大中（過去画像保持対象）

    update_interval  本地点の画像自動更新間隔(秒)
    next_update      次回更新予約時間(Epoch秒 初期値0：visibleの場合で予約時間を超えた場合に更新処理起動)
    image_list       画像リスト（タイムスタンプ(time)、時間オブジェクト（dt）、画像(image)の組みの配列)

    updating         画像データ取得中
  */
  var camera_info_update_interval = 0; // カメラ地点管理情報の自動更新間隔（秒）
  var revision = 0; // カメラ地点管理情報の更新リビジョン
  var controller; // LiveCameraデータオブジェクト（Masterを管理し、Overlay、Layerを駆動するWRAP.Dataインスタンス）
  var controller_waiting = false; // LiveCameraデータオブジェクトの初期化待ちフラグ
  var camera_master; // カメラマスタデータ
  var valid = true; // LiveCameraデータ内容の表示反映状況
  var last_valid = 0; // LiveCameraデータの前回更新時間（描画更新頻度をさげるため）
  var redraw_interval = 250; // LiveCameraレイヤーの再描画最小間隔(ms)
  var visible; // Livecameraレイヤーの表示状態
  var camera_window = []; // カメラウィンドウ
  var camera_thumbnail = []; // カメラサムネイルアイコン
  var map_size = null; // 画角サイズ
  var thumnail_mode = false; // サムネイルアイコンモード

  var overlay; // オーバーレイ管理本体
  var layer_draw_conf; // ライブカメラ レイヤー・コンフィグ
  var display_loading = []; // カメラ画像取得中のオブジェクト
  var quit = false;

  function main_loop() {
    if (quit) {
      return;
    }
    time = Date.now();

    for (var id in camera_info) {
      var c = camera_info[id];

      if (
        !c.updated ||
        (camera_info_update_interval &&
          c.updated < time - camera_info_update_interval * 1000)
      ) {
        requestCameraInfo(id);
      }

      if (
        (c.visible || (thumnail_mode && c.icon_visible)) &&
        c.next_update <= time
      ) {
        if (c.expanded) {
          requestAnimationImage(id);
        } else {
          requestLatestImage(id);
        }
      }
    }
    process(); // データリクエストの更新

    if (!valid) {
      if (last_valid + redraw_interval <= time) {
        valid = true;
        last_valid = time;
        controller.update("data", camera_master); // データリビジョンの更新 → レイヤー再描画
      }
    }

    requestAnimationFrame(main_loop);
  }

  var status = {
    camera_num: 0, // カメラ地点数
    camera_window: 0, // 表示中のカメラウインドウ数
    visible_camera_window: 0, // 画像が画角内に入っているカメラウインド数
    visible_camera_icon: 0, // 画像が画角内に入っているカメラアイコン数
    animating_camera_window: 0, // アニメーション表示中のウィンドウ数
    auto_update_camera: 0, // 自動更新対象のカメラ数
    image_data_count: 0, // 管理中のイメージデータ数
    image_data_size: 0, // 管理中のイメージデータサイズ総計
    image_data_size_total: 0, // 取得したイメージデータの累計サイズ
    request_count: 0, // データリクエスト総計
    request_complete_count: 0, // リクエスト累計正常終了件数
    request_error_count: 0, // リクエストエラーの累計発生件数
    request_timeout_count: 0, // リクエストタイムアウト累計発生件数
    current_request_wait: 0, // 現在待機(キューイング中)のリクエスト件数
    current_request_call: 0, // 現在実行中のリクエスト件数
  };

  var inspector; // ステータス監視のコールバック（アプリ側がinspectで設定）

  // 内部ステータスの更新処理
  var nop = function () {}; // no operation (更新なし)
  var addRequest = function () {
    status.request_count++;
    status.current_request_wait = queue.length;
    status.current_request_call = requesting.length;
  };
  var addResponse = function (s) {
    if (s.status === undefined) {
      status.request_complete_count++;
    } else if (
      s.status == WRAP.Data.Status.REQUEST_TIMEOUT ||
      (typeof s.status == "string" && s.status.indexof("6000") >= 0)
    ) {
      status.request_timeout_count++;
    } else {
      status.request_error_count++;
    }
    status.current_request_wait = queue.length;
    status.current_request_call = requesting.length;
  };
  var updater = {
    Configuration: nop, // コンフィグ設定が更新された
    WindowOpen: function () {
      // カメラ画像ウィンドウが開かれた
      status.camera_window++;
    },
    WindowMaximize: function (id) {
      // カメラ画像ウィンドウサイズが拡大された
      camera_info[id].expanded = true;
      camera_info[id].next_update = 0;
    },
    WindowMinimize: function (id) {
      // カメラ画像ウィンドウサイズが縮小された
      camera_info[id].expanded = false;
    },
    WindowClose: function (id) {
      //　カメラ画像ウィンドウが閉じられた
      camera_info[id].expanded = false;
      status.camera_window--;
    },
    WindowMoved: nop, //　カメラ画像ウィンドウがドラッグして位置を変えた
    WindowActive: function (id) {
      //　カメラ画像ウィンドウが画角内に入った
      camera_info[id].visible = true;
      status.auto_update_camera++;
      status.visible_camera_window++;
    },
    WindowInActive: function (id) {
      //　カメラ画像ウィンドウアイコンが画角外に出た
      camera_info[id].visible = false;
      status.auto_update_camera--;
      status.visible_camera_window--;
    },
    AnimationStart: function () {
      //　アニメーションが開始された
      status.animating_camera_window++;
    },
    AnimationEnd: function () {
      //　アニメーションが停止された
      status.animating_camera_window--;
    },
    CamearaIconActive: function () {
      //　カメラアイコンが画角内に入った
      status.visible_camera_icon++;
    },
    CamearaIconInActive: function () {
      //　カメラアイコンが画角外に出た
      status.visible_camera_icon--;
    },
    CameraMasterRequest: function () {
      //　カメラマスタがリクエストされた
      addRequest();
    },
    CameraMasterResponse: function (id, s) {
      //　カメラマスタのレスポンス
      __unused(id);
      addResponse(s);
    },
    CameraMasterUpdated: function (id, s) {
      //　カメラマスタが更新された
      __unused(id);
      status.camera_num = s.count;
    },
    CameraInfoRequest: function () {
      // カメラ地点情報がリクエストされた
      addRequest();
    },
    CameraInfoResponse: function (id, s) {
      //　カメラ地点情報のレスポンス
      __unused(id);
      addResponse(s);
    },
    ImageFileListRequest: function () {
      //　カメラ画像リストがリクエストされた
      addRequest();
    },
    ImageFileListResponse: function (id, s) {
      // カメラ画像リストのレスポンス
      __unused(id);
      addResponse(s);
    },
    LatestImageFileRequest: function () {
      //　カメラ最新画像情報がリクエストされた
      addRequest();
    },
    LatestImageFileResponse: function (id, s) {
      //　カメラ最新画像情報のレスポンス
      __unused(id);
      addResponse(s);
      var cam = camera_info[id];
    },
    ImageFileRequest: function () {
      //　イメージファイルのロード
      addRequest();
    },
    ImageFileResponse: function (id, s) {
      //　イメージファイルのロードが完了した
      __unused(id);
      addResponse(s);
    },
    LayerShow: nop, // レイヤーが表示された
    LayerHide: nop, //　レイヤーが非表示になった
    LayerDraw: nop, //　レイヤー描画内容が更新された
    WindowMax: nop, // 表示中のWindowが最大数であるため、 新しいウィンドウを開けなかった
    PurgeData: function (id, s) {
      // 管理データサイズがオーバーフローしたため古いデータをパージした
      var cam = camera_info[id];
      cam.next_update = 0;
    },
    Debug: nop,
  };

  function event(type, camera, status, category) {
    if (!updater[type]) {
      debug({ error: "invalid event type [" + type + "]" });
    }
    updater[type](camera, status);
    inspector &&
      inspector({
        type: type,
        camera: camera,
        status: status,
        category: category, // 'info', 'error', 'debug'
        timestamp: time,
      });
  }

  function update(type, camera, status) {
    event(type, camera, status, "info");
  }

  function error(type, camera, status) {
    event(type, camera, status, "error");
  }

  function debug(info) {
    event("Debug", null, info, "debug");
    //var msg = info && (info.info || info.error)
    //msg && console.debug("- Livecamera "+msg)
  }

  function invalidate() {
    valid = false;
    revision++;
  }

  function override(data_conf) {
    for (var element in data_conf) {
      if (conf[element] === undefined) {
        continue;
      }
      var v = data_conf[element];
      if (typeof v == "string") {
        conf[element] = v;
      } else if (conf[element] < v) {
        conf[element] = v;
      }
    }
    update("Configuration", null, conf);
  }

  // カメラ情報の更新
  function updateCamera(data) {
    /*
      WRAP-JSによりマスタは重複管理されているので、新しいcamera_infoを構築して差し替える。
      古いデータ側の内容をオーバライドする。
    */
    camera_master = data;
    var count = 0;
    var new_info = {};
    data.forEach((l) => {
      const key = l.config.camid;
      const t = (new_info[key] = {
        active: false,
        config: l.config,
        controller: l.controller,
        id: l.config.camid,
        image_list: [],
        name: "LNAME",
        next_update: 0,
        update_interval: conf.update_interval,
        updated: 0,
        updating: false,
      });
      var l = camera_info[key];
      if (l) {
        for (const k in l) {
          t[k] = l[k];
        }
        overlay.updateCamera(t);
      }
      count++;
    });
    camera_info = new_info;
    update("CameraMasterUpdated", null, { count: count });
  }

  function requestCameraInfo(id) {
    var c = camera_info[id];
    if (!c) {
      return;
    }
    c.updated = Number.MAX_VALUE;

    if ((c = camera_info[id])) {
      const config = c.config;
      c.LNAME = config.name;
      c.STATUS = config.status ?? 1;
      c.TZ = "";
      c.JPSCSN = "";
      c.lat = parseFloat(config.lat) * 60.0;
      c.lon = parseFloat(config.lon) * 60.0;
      const noDirection = config.dir === -1 || config.dir === "";
      c.dir = !noDirection ? config.dir * (360 / 16) - 90 : undefined;
      c.updated = time;
      invalidate(); //  データを更新してレイヤーを再描画させる。
    }
    update("CameraInfoResponse", id, {});
  }

  function endUpdate(id) {
    var c = camera_info[id];
    if (c) {
      c.next_update = time + conf.update_interval * 1000;
      c.updating = false;
      var l = display_loading.indexOf(id);
      if (l >= 0) {
        overlay.clearImage(id);
        display_loading.splice(l, 1);
      }
    }
  }

  function recoverUpdate(id) {
    /*
      自動更新
      　非expanded→requestLatestImage
      　expanded時→requestAnimationImage
      requestLatestImage処理中に expandedとなると次回呼び出しがupdate_interval分waitするため
      本処理によりwaitを回避する
    */
    var c = camera_info[id];
    if (c && c.expanded) {
      c.next_update = 0;
    }
  }

  function requestImage(id, file, end) {
    try {
      var c = camera_info[id];
      update("ImageFileRequest", id);
      request({
        data: controller,
        source: "ImageFile",
        option: {
          camera_id: id,
          file: file.file,
        },
        success: function (r) {
          try {
            if ((c = camera_info[id])) {
              const time = file.utc;
              addImage(id, time, r.image, true);
              update("ImageFileResponse", id, { time: time });
              end();
            }
          } catch (e) {
            end();
            console.error(e.message);
          }
        },
        error: function (url, data, status) {
          try {
            if ((c = camera_info[id])) {
              var image = new Image();
              image.src =
                (layer_draw_conf && layer_draw_conf.Attributes.error_image) ||
                "img/broken_img.png";
              const time = file.utc;
              addImage(id, time, image);
              error("ImageFileResponse", id, { status: status, url: url });
              end();
            }
          } catch (e) {
            end();
            console.error(e.message);
          }
        },
      });
    } catch (e) {
      end();
      console.error(e.message);
    }
  }

  function pad0(n) {
    return String(n).padStart(2, '0');
  }

  function parseImageList(imageList) {
    imageList.forEach(i => {
      const jst = i.file.split('.')[0];
      const jYear = Number(jst.slice(0, 4));
      const jMonth = Number(jst.slice(4, 6)) - 1;
      const jDay = Number(jst.slice(6, 8));
      const jHour = Number(jst.slice(8, 10));
      const jMin = Number(jst.slice(10, 12));
      const jSec = Number(jst.slice(12, 14));
      const jstDate = new Date(jYear, jMonth, jDay, jHour, jMin, jSec);

      const uYear  = jstDate.getUTCFullYear();
      const uMonth = pad0(jstDate.getUTCMonth() + 1);
      const uDay   = pad0(jstDate.getUTCDate());
      const uHour  = pad0(jstDate.getUTCHours());
      const uMin   = pad0(jstDate.getUTCMinutes());
      const uSec   = pad0(jstDate.getUTCSeconds());
      i.utc = `${uYear}${uMonth}${uDay}${uHour}${uMin}${uSec}`;
    });
    imageList.sort((a, b) => b.time - a.time);
    return imageList;
  }

  function requestLatestImage(id) {
    var c = camera_info[id];
    if (!c) {
      return;
    }
    if (c.STATUS == 0) {
      endUpdate(id);
      overlay.updateImage(id);
      return;
    }
    if (c.updating) {
      // 10分以上updateingのままとなっている地点は強制的に再更新する（fail-safe）
      if (time - c.updating_time >= 10 * 60 * 1000) {
        c.updating = false;
      } else {
        return;
      }
    }
    var latest_timestamp = c.image_list.length && c.image_list[0].time;
    if (latest_timestamp) {
      var lt = new WRAP.Core.DateTime(latest_timestamp);
      var dt = new WRAP.Core.DateTime(new Date(time));
      if (lt.diff(dt) < conf.update_interval) {
        return;
      }
    }
    try {
      c.updating = true;
      c.updating_time = time;
      update("LatestImageFileRequest", id);
      request({
        data: c.controller,
        source: "ImageFileList",
        option: {
          camera_id: c.id,
        },
        success: function (r) {
          c.time_list = parseImageList(r.image_list);
          if (c.time_list.length !== 0) {
            requestImage(id, c.time_list[0], function () {
              endUpdate(id);
              recoverUpdate(id);
              update("LatestImageFileResponse", id, { response: r });
            });
          }
        },
        error: function (url, status) {
          if ((c = camera_info[id])) {
            endUpdate(id);
            recoverUpdate(id);
            error("LatestImageFileResponse", id, { status: status, url: url });
          }
        },
      });
    } catch (e) {
      endUpdate(id);
      console.error(e.message);
    }
  }

  function requestAnimationImage(id) {
    var c = camera_info[id];
    if (!c || c.updating) {
      return;
    }
    c.updating = true;
    update("ImageFileListRequest", id);
    request({
      data: c.controller,
      source: "ImageFileList",
      option: {
        camera_id: c.id,
      },
      success: function (files) {
        c.time_list = parseImageList(files.image_list);
        var count = c.time_list.length;
        c.time_list.forEach((t) => {
          requestImage(id, t, () => {
            if (!--count) {
              endUpdate(id);
            }
          });
        });
      },
      error: function (url, status) {
        if ((c = camera_info[id])) {
          endUpdate(id);
          error("ImageFileListResponse", id, { status: status, url: url });
        }
      },
    });
  }

  // イメージデータの更新
  function addImage(id, timestamp, image, valid, thumbnail) {
    var info = camera_info[id];
    if (!info) {
      return;
    }
    var dt = new WRAP.Core.DateTime(timestamp);
    var list = info.image_list;
    var index = 0;
    while (index < list.length) {
      var l = list[index];
      var d = dt.diff(l.dt);
      if (d == 0) {
        list.splice(index, 1);
        break;
      } else if (d < 0) {
        break;
      }
      index++;
    }
    var size = image.width * image.height * 4;
    status.image_data_count++;
    status.image_data_size += size;
    status.image_data_size_total += size;
    var e = {
      time: timestamp,
      dt: dt,
      image: image,
      size: size,
      thumbnail: thumbnail,
      valid: valid,
    };
    if (index < list.length) {
      list.splice(index, 0, e);
    } else {
      list.push(e);
    }

    while (list.length > image_generation) {
      index = list.length - 1;
      status.image_data_count--;
      status.image_data_size -= list[index].size;
      list.splice(index, 1);
    }
    //　データサイズの制限を超えていたら、古いデータをパージする
    var oldest;
    while (status.image_data_size > conf.image_data_limit) {
      // 不可視の最古データ
      oldest = null;
      for (var i in camera_info) {
        var c = camera_info[i];
        if (!c.visible && c.image_list.length) {
          var t = c.image_list[c.image_list.length - 1];
          if ((id !== i && timestamp !== t.time) && (!oldest || oldest.time > t.time)) {
            oldest = { id: i, time: t.time };
          }
        }
      }
      if (!oldest) {
        break;
      }
      var c = camera_info[oldest.id];
      var target = c.image_list[c.image_list.length - 1];
      status.image_data_size -= target.size;
      status.image_data_count--;
      c.image_list.splice(c.image_list.length - 1, 1);
      update("PurgeData", oldest.id, { time: target.time });
    }
    overlay.updateImage(id);
  }

  /*
    通信制御部
  */
  var queue = [];
  var requesting = [];
  var last_request_time = 0;

  // データのリクエストを登録
  function request(r) {
    //categoryによってデータ取得先を切り替えるため、baseUrlにcategoryを設定してconfigのaliasで切り替える
    r.option = {
      ...r.option,
      baseUrl: r.option.camerapath,
    };
    queue.push(r);
  }

  // データのリクエスト・キューを更新
  function process() {
    if (time - last_request_time < conf.min_request_interval) {
      return;
    }
    while (queue.length && requesting.length < (conf.download_max || 1)) {
      load(queue.pop()); // 新しいリクエストから処理する
      last_request_time = time;
    }
  }

  function load(r) {
    requesting.push(r);
    r.data.load(
      r.source,
      r.option,
      true,
      function (data) {
        complete(r);
        r.success(data);
      },
      function (url, data, status, desc) {
        complete(r);
        r.error(url, data, status, desc);
      }
    );
  }

  function complete(r) {
    var i = requesting.indexOf(r);
    if (i >= 0) {
      requesting.splice(i, 1);
    }
  }

  function getStyle(conf, style) {
    var d = conf.Attributes.style.default;
    var c = {
      overlap_margin: d.icon_overlap_margin || 0,
      mini_overlap_margin: d.icon_overlap_margin || 0,
      icon: {
        image: d.icon || d.icon_s,
        width: d.icon_width,
        height: d.icon_height,
        offset_x: d.icon_offset_x,
        offset_y: d.icon_offset_y,
      },
      icon_nondir: {
        image: d.icon || d.icon_s,
        width: d.icon_width,
        height: d.icon_height,
        offset_x: d.icon_offset_x,
        offset_y: d.icon_offset_y,
      },
      unavailable_icon: {
        image: d.icon || d.icon_s,
        width: d.icon_width,
        height: d.icon_height,
        offset_x: d.icon_offset_x,
        offset_y: d.icon_offset_y,
      },
      mini_icon: {
        image: d.mini_icon || d.icon || d.icon_s,
        width: d.mini_icon_width,
        height: d.mini_icon_height,
        offset_x: d.mini_icon_offset_x,
        offset_y: d.mini_icon_offset_y,
      },
      mini_icon_nondir: {
        image: d.mini_icon || d.icon || d.icon_s,
        width: d.mini_icon_width,
        height: d.mini_icon_height,
        offset_x: d.mini_icon_offset_x,
        offset_y: d.mini_icon_offset_y,
      },
      mini_unavailable_icon: {
        image: d.mini_icon || d.icon || d.icon_s,
        width: d.mini_icon_width,
        height: d.mini_icon_height,
        offset_x: d.mini_icon_offset_x,
        offset_y: d.mini_icon_offset_y,
      },
    };
    if (d.icon_nondir != undefined) {
      c.icon_nondir.image = d.icon_nondir;
    }
    if (d.icon_nondir_width != undefined) {
      c.icon_nondir.width = d.icon_nondir_width;
    }
    if (d.icon_nondir_height != undefined) {
      c.icon_nondir.height = d.icon_nondir_height;
    }
    if (d.icon_nondir_offset_x != undefined) {
      c.icon_nondir.offset_x = d.icon_nondir_offset_x;
    }
    if (d.icon_nondir_offset_y != undefined) {
      c.icon_nondir.offset_y = d.icon_nondir_offset_y;
    }
    if (d.unavailable_icon != undefined) {
      c.unavailable_icon_defined = c.unavailable_icon.image =
        d.unavailable_icon;
    }

    if (d.mini_icon_overlap_margin != undefined) {
      c.mini_overlap_margin = d.mini_icon_overlap_margin;
    }
    if (d.mini_icon_nondir != undefined) {
      c.mini_icon_nondir.image = d.mini_icon_nondir;
    }
    if (d.mini_icon_nondir_width != undefined) {
      c.mini_icon_nondir.width = d.mini_icon_nondir_width;
    }
    if (d.mini_icon_nondir_height != undefined) {
      c.mini_icon_nondir.height = d.mini_icon_nondir_height;
    }
    if (d.mini_icon_nondir_offset_x != undefined) {
      c.mini_icon_nondir.offset_x = d.mini_icon_nondir_offset_x;
    }
    if (d.mini_icon_nondir_offset_y != undefined) {
      c.mini_icon_nondir.offset_y = d.mini_icon_nondir_offset_y;
    }
    if (d.mini_unavailable_icon != undefined) {
      c.mini_unavailable_icon_defined = c.mini_unavailable_icon.image =
        d.mini_unavailable_icon;
    }

    var s = style && conf.Attributes.style[style];
    if (s) {
      if (s.icon_overlap_margin != undefined) {
        c.icon_overlap_margin = s.icon_overlap_margin;
      }
      if ((s.icon || s.icon_s) != undefined) {
        c.icon.image = s.icon || s.icon_s;
      }
      if (s.icon_width != undefined) {
        c.icon.width = s.icon_width;
      }
      if (s.icon_height != undefined) {
        c.icon.height = s.icon_height;
      }
      if (s.icon_offset_x != undefined) {
        c.icon.offset_x = s.icon_offset_x;
      }
      if (s.icon_offset_y != undefined) {
        c.icon.offset_y = s.icon_offset_y;
      }
      if (s.icon_nondir != undefined) {
        c.icon_nondir.image = s.icon_nondir;
      }
      if (s.icon_nondir_width != undefined) {
        c.icon_nondir.width = s.icon_nondir_width;
      }
      if (s.icon_nondir_height != undefined) {
        c.icon_nondir.height = s.icon_nondir_height;
      }
      if (s.icon_nondir_offset_x != undefined) {
        c.icon_nondir.offset_x = s.icon_nondir_offset_x;
      }
      if (s.icon_nondir_offset_y != undefined) {
        c.icon_nondir.offset_y = s.icon_nondir_offset_y;
      }
      if (s.unavailable_icon != undefined) {
        c.unavailable_icon_defined = c.unavailable_icon.image =
          s.unavailable_icon;
      }

      if (s.mini_icon_overlap_margin != undefined) {
        c.mini_icon_overlap_margin = s.mini_icon_overlap_margin;
      }
      if (s.mini_icon != undefined) {
        c.mini_icon.image = s.mini_icon;
      }
      if (s.mini_icon_width != undefined) {
        c.mini_icon.width = s.mini_icon_width;
      }
      if (s.mini_icon_height != undefined) {
        c.mini_icon.height = s.mini_icon_height;
      }
      if (s.mini_icon_offset_x != undefined) {
        c.mini_icon.offset_x = s.mini_icon_offset_x;
      }
      if (s.mini_icon_offset_y != undefined) {
        c.mini_icon.offset_y = s.mini_icon_offset_y;
      }
      if (s.mini_icon_nondir != undefined) {
        c.mini_icon_nondir.image = s.mini_icon_nondir;
      }
      if (s.mini_icon_nondir_width != undefined) {
        c.mini_icon_nondir.width = s.mini_icon_nondir_width;
      }
      if (s.mini_icon_nondir_height != undefined) {
        c.mini_icon_nondir.height = s.mini_icon_nondir_height;
      }
      if (s.mini_icon_nondir_offset_x != undefined) {
        c.mini_icon_nondir.offset_x = s.mini_icon_nondir_offset_x;
      }
      if (s.mini_icon_nondir_offset_y != undefined) {
        c.mini_icon_nondir.offset_y = s.mini_icon_nondir_offset_y;
      }
      if (s.mini_unavailable_icon != undefined) {
        c.mini_unavailable_icon_defined = c.mini_unavailable_icon.image =
          s.mini_unavailable_icon;
      }
    }
    return c;
  }

  this.initial_fade = false;

  this.draw = function (layer, content, conf, context, style, data, rev) {
    if (!ready(data, layer)) {
      return;
    }

    WRAP.Geo.check(content, context, style);

    var loaded = status.camera_num && this.camera_num >= status.camera_num;
    var thumbnail_mode_changed = false;
    var tm = layer.visible() && loaded && conf.Attributes.thumbnail_icon;
    if ((thumbnail_mode_changed = !thumnail_mode != !tm)) {
      if (!(thumnail_mode = tm)) {
        overlay.clearThumbnail();
      }
    }

    if (this.conf_revision != rev.conf) {
      this.conf_revision = rev.conf;
      layer_draw_conf = conf;
      for (var i = 0; i < camera_window.length; i++) {
        var cw = camera_window[i];
        if (cw.visible) {
          cw.setImage(cw.index);
        }
      }
    }

    if (layer.visible() && !visible) {
      // レイヤーの可視状態とオーバーレイの可視状態が不一致の場合は、レイヤーをhide/showして
      // visibilityChangeイベントを発火させる（初期化順によるイベント漏れ対策）
      debug({ info: "force visibility event" });
      setTimeout(function () {
        layer.hide();
        layer.show();
      }, 1);
    }

    if (!conf.Attributes.style) {
      layer.setStatus({
        status: "error",
        reason: "invalid layer configuration.",
      });
      return;
    }

    if (context.projection.move_sensitive) {
      this.context_revision = 0;
    }

    if (conf.Attributes.mini_icon_zoom != undefined) {
      var mini_icon = context.zoom <= conf.Attributes.mini_icon_zoom;
      if (this.mini_icon != mini_icon) {
        this.mini_icon = mini_icon;
        this.context_revision = -1;
      }
    }

    // データ、コンテキスト（画角）が変更した時だけ描画を行う
    if (
      this.revision == revision && // camera_info リビジョン
      this.data_revision == rev.data &&
      this.context_revision == rev.context &&
      !thumbnail_mode_changed
    )
      return;

    if (overlay) {
      overlay.setStyle(conf);
    }
    var count = 0;
    for (var key in camera_info) {
      var c = camera_info[key];
      if (
        c.error ||
        c.lat != undefined ||
        c.lon != undefined ||
        c.ENAME ||
        c.LNAME
      ) {
        count++;
      }
    }

    var icon_overlap = false;
    for (var s in conf.Attributes.style) {
      if (conf.Attributes.style[s].icon_overlap_margin !== undefined) {
        icon_overlap = true;
        break;
      }
    }

    // カメラ・アイコンの描画
    layer.setStatus({ status: "invalid", reason: "drawing camera icons." });
    layer.clear();
    var initial_icon_fadein =
      conf.Attributes.initial_icon_fadein !== undefined
        ? conf.Attributes.initial_icon_fadein
        : 0.0;
    var initial_icon_fadeout =
      conf.Attributes.initial_icon_fadeout !== undefined
        ? conf.Attributes.initial_icon_fadeout
        : 0.75;
    var icon_fadein =
      conf.Attributes.icon_fadein !== undefined
        ? conf.Attributes.icon_fadein
        : 0.5;
    var icon_fadeout =
      conf.Attributes.icon_fadeout !== undefined
        ? conf.Attributes.icon_fadeout
        : 0.75;

    var mask;
    if (loaded && icon_overlap) {
      mask = WRAP.Geo.getMask();
      mask.clear();
    }
    for (var key in camera_info) {
      var c = camera_info[key];
      if (c.error) {
        layer.setStatus({ status: "error", reason: "camera info load error" });
      }
      if (!conf.Attributes.target_type.includes(c.config.type)) {
        continue;
      }
      if (c.lat && c.lon) {
        var style = getStyle(conf, c.style);

        var point = [c.lon / 60.0, c.lat / 60.0];
        var overlap_margin = 0;
        var icon_visible = c.icon_visible ?? true;
        var icon = style.icon;

        if (!this.mini_icon) {
          overlap_margin = style.overlap_margin;
          if (c.dir === undefined) {
            icon = style.icon_nondir;
          }
          if (c.STATUS == 0) {
            if (c.dir !== undefined || style.unavailable_icon_defined)
              icon = style.unavailable_icon;
          }
        } else {
          overlap_margin = style.mini_overlap_margin;
          if (c.dir === undefined) icon = style.mini_icon_nondir;
          else icon = style.mini_icon;
          if (c.STATUS == 0) {
            if (c.dir !== undefined || style.mini_unavailable_icon_defined)
              icon = style.mini_unavailable_icon;
          }
        }

        if (mask) {
          var os =
            (icon.width > icon.height ? icon.width : icon.height) -
            overlap_margin * 2;
          if (os > 0) {
            var op = -os / 2;
            if (mask.intersectRect(point, op, op, os, os)) {
              icon_visible = false;
            } else {
              mask.addRect(point, op, op, os, os);
            }
          }
        }
        if (icon_visible) {
          var dir =
            c.dir === undefined
              ? 0
              : WRAP.Geo.getScreenRotation(
                  new WRAP.Geo.Point(c.lat, c.lon),
                  c.dir
                );
          var feature = new WRAP.Geo.Feature.Image({
            point: point,
            image: icon.image,
            width: icon.width,
            height: icon.height,
            offsetX: icon.offset_x,
            offsetY: icon.offset_y,
            rotation: dir,
          });
          feature.set(layer, c);
          if (c.icon) {
            feature.alpha = c.icon.alpha;
            feature.fade = c.icon.fade;
          } else {
            feature.alpha = 0.0;
          }
          feature.fadeIn(loaded ? icon_fadein : initial_icon_fadein);
          c.icon = feature;
          layer.addFeature(feature);
          if (thumnail_mode) {
            overlay.showThumbnail(c, conf, layer, feature);
          }
        } else {
          if (c.icon) {
            if (c.icon.alpha > 0.01) {
              c.icon.fadeOut(
                this.initial_fade ? icon_fadeout : initial_icon_fadeout
              );
              layer.addFeature(c.icon);
            }
            c.icon = null;
          }
          if (thumnail_mode) {
            overlay.hideThumbnail(c);
          }
        }
      }
    }
    if (mask && !this.initial_fade) {
      this.initial_fade = true;
    }
    if (thumnail_mode) {
      overlay.updateCameraThumbnail();
    }
    this.camera_num = count;
    this.revision = revision;
    this.data_revision = rev.data;
    this.context_revision = rev.context;
    if (layer.getStatus().status != "error") {
      layer.setStatus({ status: "valid" });
    }
    WRAP.Geo.invalidate();
    update("LayerDraw");
    if (icon_overlap && loaded && !this.initial_fade) {
      setTimeout(function () {
        layer.context_revision = 0;
        WRAP.Geo.redraw(layer);
      }, 500);
    }
  };

  this.clear = function () {
    if (overlay) {
      overlay.clear();
    }
    quit = true;
  };

  /*
    オーバーレイ（ポップアップ・ウィンドウ）管理
  */

  var Overlay = function (data) {
    var interaction;
    var base;
    var style_initialized;
    var current_camera;
    var camera_ox = 10;
    var camera_oy = 10;
    var camera_z = WRAP.Configuration.overlay.z.livecamera;
    var camera_w = 640;
    var camera_h = 480;
    var camera_s = 0.3;
    // [SKY_FOSTER_LINKS-120] ライブカメラのサイズアップ
    // var camera_m = 0.6;
    var camera_m = 0.75;
    var camera_header = 26;
    var camera_footer = 20;
    var camera_bgcolor = "#f2f2f2";
    var camera_border = "rgba(150,150,150,0.6)";
    var camera_sw = Math.floor(camera_w * camera_s);
    var camera_sh = Math.floor(camera_h * camera_s);
    var camera_mw = Math.floor(camera_w * camera_m);
    var camera_mh = Math.floor(camera_h * camera_m);
    var close_button = "img/closebtn.png";
    var zoom_in_button = "img/bt_zoomIn.png";
    var zoom_out_button = "img/bt_zoomOut.png";

    var style = function () {
      return (
        ".smooth_tran {" +
        "-webkit-transition-duration : 0.2s;" +
        "-moz-transition-duration : 0.2s;" +
        "-o-transition-duration : 0.2s;" +
        "-ms-transition-duration : 0.2s;" +
        "}" +
        ".current_window {" +
        "box-shadow : 0px 0px 50px #fff;" +
        "border: 1px solid #fff;" +
        "}" +
        ".live_camera {" +
        "position: absolute;" +
        "background-color: " +
        camera_bgcolor +
        ";" +
        "border: 1px solid " +
        camera_border +
        ";" +
        "user-select: none;" +
        "-webkit-user-select: none;" +
        "-moz-user-select: none;" +
        "-ms-user-select: none;" +
        "outline: 0;" +
        "box-sizing: content-box;" +
        "}" +
        ".small_window {" +
        "width: " +
        camera_sw +
        "px;" +
        "height: " +
        (camera_sh + camera_header) +
        "px;" +
        "}" +
        ".middle_window {" +
        "width: " +
        camera_mw +
        "px;" +
        "height: " +
        (camera_mh + camera_header + camera_footer) +
        "px;" +
        "}" +
        ".image_s {" +
        "position: absolute;" +
        "width: 100%;" +
        "height: " +
        camera_sh +
        "px;" +
        "top: " +
        camera_header +
        "px;" +
        "background-color: #bbb;" +
        "}" +
        ".image_m {" +
        "position: absolute;" +
        "width: 100%;" +
        "height: " +
        camera_mh +
        "px;" +
        "top: " +
        camera_header +
        "px;" +
        "background-color: #bbb;" +
        "}" +
        ".camera_button {" +
        "position: absolute;" +
        "width:20px;" +
        "height:20px;" +
        "padding:0;" +
        "border:solid 1px rgba(0,0,0,0);" +
        "border-radius:4px;" +
        "cursor:pointer;" +
        "user-select: none;" +
        "-webkit-user-select: none;" +
        "-moz-user-select: none;" +
        "-ms-user-select: none;" +
        "}" +
        ".camera_button:hover {" +
        "border:solid 1px rgba(150,150,150,0.8);" +
        "}" +
        ".camera_zoomin {" +
        "top:3px; right:28px;" +
        "background:url(" +
        zoom_in_button +
        ") no-repeat left top;" +
        "}" +
        ".camera_zoomout {" +
        "top:3px; right:28px;" +
        "background:url(" +
        zoom_out_button +
        ") no-repeat left top;" +
        "}" +
        ".camera_close {" +
        "top:3px; right:4px;" +
        "background:url(" +
        close_button +
        ") no-repeat left top;" +
        "}" +
        ".camera_text {" +
        'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;' +
        "user-select: none;" +
        "-webkit-user-select: none;" +
        "-moz-user-select: none;" +
        "-ms-user-select: none;" +
        "cursor:default;" +
        "position: absolute;" +
        "font-size:11px;" +
        "line-height: 1.5em;" +
        "vertical-align: baseline;" +
        "color:black;" +
        "height:15px;" +
        "}" +
        ".camera_name {" +
        "top:0px; left:4px; right:54px;" +
        "text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" +
        "}" +
        ".camera_time {" +
        "top:12px; left:4px; width:180px; background:transparent;" +
        "}" +
        ".live_camera.middle_window > .short {" +
        "right:226px;" +
        "}" +
        ".camera_time_button {" +
        'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;' +
        "font-size:10px;" +
        "line-height: 1.0em;" +
        "color:black;" +
        "position: absolute;" +
        "bottom:1px;" +
        "width:32px;" +
        "height:18px;" +
        "padding-top:2px;" +
        "vertical-align:middle;" +
        "border:solid 1px rgba(120,120,120,1.0);" +
        "border-radius:4px;" +
        "background-color: " +
        camera_bgcolor +
        ";" +
        "cursor:pointer;" +
        "}" +
        ".camera_time_button:hover {" +
        "background: #fefeff;" +
        "}" +
        ".camera_time_button:disabled {" +
        "color:#999;" +
        "border:solid 1px rgba(170,170,170,0.8);" +
        "pointer-events: none;" +
        "cursor:default;" +
        "}" +
        ".live_camera > .expire {" +
        "display: none;" +
        "position: absolute;" +
        "color: #FF0000;" +
        'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;' +
        "line-height: 1.5em;" +
        "font-weight: bold;" +
        "font-size: 12px;" +
        "}" +
        ".live_camera.small_window > .expire {" +
        "top:26px;" +
        "left:3px;" +
        "}" +
        ".live_camera.middle_window > .expire {" +
        "top:6px;" +
        "right:52px;" +
        "}" +
        ".live_camera_thumbnail {" +
        "position:absolute;" +
        //            "border:solid 1px rgba(100,100,100,0.7);"+
        "}" +
        ".live_camera_thumbnail:hover {" +
        "opacity:0.0;" +
        //            "border:solid 1px rgba(100,100,100,0.0);"+
        "}" +
        "@keyframes slide-left {" +
        "from {" +
        "margin-left: 100%;" +
        "}" +
        "to {" +
        "margin-left: 0%;" +
        "}" +
        "}" +
        "@keyframes slide-right {" +
        "from {" +
        "margin-left: -100%;" +
        "}" +
        "to {" +
        "margin-left: 0%;" +
        "}" +
        "}"
      );
    };

    function showCameraWindow(cd, layer) {
      var cw;
      if (!(cw = findCameraWindow(cd.id))) {
        cw = new LiveCameraWindow(cd, layer._conf);
      }
      activateCameraWindow(cw);
      if (current_camera != cw) {
        var last_camera = current_camera;
        if (current_camera && current_camera.tooltip) {
          current_camera.hide();
        }
        current_camera = cw;
        if (last_camera) {
          last_camera.set();
        }
        if (!current_camera.visible) {
          current_camera.tooltip = true;
          cw.show(cd.lat, cd.lon);
        }
        current_camera.set();
      }
    }

    function updateCameraWindowStatus() {
      for (var i = 0; i < camera_window.length; i++) {
        var cw = camera_window[i];
        cw.updateImageStatus();
      }
    }

    function updateCameraThumbnail() {
      //var count = 0;
      for (var i = 0; i < camera_thumbnail.length; i++) {
        var ct = camera_thumbnail[i];
        var in_map = false;
        if (ct.icon.style.display == "block") {
          var x = parseFloat(ct.icon.style.left.replace("px", ""));
          var y = parseFloat(ct.icon.style.top.replace("px", ""));
          var sx = x;
          var sy = y;
          var ex = sx + ct.icon.clientWidth;
          var ey = sy + ct.icon.clientHeight;
          in_map =
            0 < ex && sx < map_size.width && 0 < ey && sy < map_size.height;
          //count++;
        }
        if (!ct.camera.icon_visible && in_map) {
          ct.camera.next_update = 0;
        }
        ct.camera.icon_visible = in_map;
      }
    }

    function mouseOverHandler(layer, feature) {
      if (!layer || layer.data() != data) {
        return;
      }
      var cd = feature && feature.reference;
      if (!cd) {
        return;
      }
      showCameraWindow(cd, layer);
      interaction.clearTooltip();
    }

    function mouseOutHandler(layer /*, data, point*/) {
      if (!layer || layer.data() != data) {
        return;
      }
      interaction.clearTooltip();
      if (current_camera && current_camera.tooltip) {
        current_camera.hide();
      }
      var last_camera = current_camera;
      current_camera = null;
      if (last_camera) last_camera.set();
    }

    function touchHandler(layer, feature) {
      if (!layer || layer.data() != data) {
        return;
      }
      if (status.camera_window > conf.max_window) {
        alert("Cannot open live camera window.\nMaximum number of windows.");
        return;
      }
      var cd = feature && feature.reference;
      if (!cd || cd.STATUS == 0) {
        return;
      }
      showCameraWindow(cd, layer);
      interaction.clearTooltip();
      if (current_camera && current_camera.tooltip) {
        current_camera.tooltip = false;
        current_camera.set();
      }
    }

    function boundsChangeHandler() {
      map_size = WRAP.Geo.getSize();
      updateCameraWindowStatus();

      for (var i = 0; i < camera_thumbnail.length; i++) {
        var t = camera_thumbnail[i];
        var sp = WRAP.Geo.getScreenPoint(t.icon.point);
        var gp = WRAP.Geo.getPoint(sp);
        var visible = !isNaN(gp.lat) && !isNaN(gp.lon);
        t.icon.style.opacity = visible ? 1.0 : 0.0;
        sp.x += t.icon.ox;
        sp.y += t.icon.oy;
        t.icon.style.left = sp.x + "px";
        t.icon.style.top = sp.y + "px";
      }
      updateCameraThumbnail();
    }

    function visibilityChangeHandler(layer) {
      if (layer.data() != data) {
        return;
      }
      visible = layer.visible();
      map_size = visible ? WRAP.Geo.getSize() : null;
      update(visible?'LayerShow':'LayerHide');// このイベントを受けた先の処理でmap_sizeが必要なのでmap_size更新後に飛ばす
      for (var i = 0; i < camera_window.length; i++) {
        var w = camera_window[i];
        w[visible ? "resume" : "suspend"]();
        w.setAnimation(false);
      }
      data.setAutoUpdate("data", visible);
      debug({
        info:
          "visibilityChange visible=" +
          visible +
          " camera_master=" +
          camera_master,
      });
      if (visible && !camera_master)
        // レイヤーが可視になったとき初回のみマスタを強制ロードする（２回目以降は自動更新設定にしたがう）
        data.load("data");
      updateCameraWindowStatus();

      if (!visible) {
        overlay.clearThumbnail();
      } else {
        layer.invalidate();
      }
    }

    function findCameraWindow(name) {
      for (var i = 0; i < camera_window.length; i++) {
        if (camera_window[i].camera.id == name) return camera_window[i];
      }
      return null;
    }

    function findCameraThumbnail(name) {
      for (var i = 0; i < camera_thumbnail.length; i++) {
        if (camera_thumbnail[i].camera.id == name) return camera_thumbnail[i];
      }
      return null;
    }

    function activateCameraWindow(target) {
      var index = camera_z;
      var i = 0;
      while (i < camera_window.length) {
        var cw = camera_window[i];
        if (cw == target) {
          var j = i + 1;
          while (j < camera_window.length) {
            cw = camera_window[j - 1] = camera_window[j];
            cw.window.style["z-index"] = index++;
            j++;
          }
          camera_window[j - 1] = target;
          break;
        } else {
          cw.window.style["z-index"] = index++;
        }
        i++;
      }
      if (i == camera_window.length) camera_window.push(target);
      target.window.style["z-index"] = index;
    }

    var dragging;
    var drag_x, drag_y;
    var offset_x, offset_y;

    function mouseMoveHandler(evt) {
      if (dragging) {
        var x, y;
        if (evt.touches) {
          x = evt.touches[0].pageX - offset_x;
          y = evt.touches[0].pageY - offset_y;
        } else {
          x = evt.clientX - offset_x;
          y = evt.clientY - offset_y;
        }
        dragging.controller.pinned = true;
        dragging.point = WRAP.Geo.getPoint(
          new WRAP.Geo.ScreenPoint(
            x - dragging.controller.ox,
            y - dragging.controller.oy
          )
        );
        dragging.style.left = x + "px";
        dragging.style.top = y + "px";
        update("WindowMoved", dragging.controller.camera.id, {
          pos: x.toFixed(0) + "," + y.toFixed(0),
        });
      }
      evt._prevent = true;
      evt.preventDefault();
    }

    function LiveCameraWindow(camera, layer_conf) {
      var self = this;
      this.camera = camera;
      camera.next_update = 0;
      this.conf = layer_conf;

      this.visible = false;
      this.small = true;
      this.pinned = true;
      this.tooltip = true;
      this.animating = false;
      this.smooth = false;

      var w = (this.window = document.createElement("div"));
      w.controller = this;
      w.style.display = "none";
      w.setAttribute("class", "live_camera small_window");

      var c = (this.canvas = document.createElement("div"));
      c.width = camera_w;
      c.height = camera_h;
      c.setAttribute("class", "image_s");

      var col = "#555";
      var size = "30";
      var l = display_loading.indexOf(camera.id);
      if (l < 0) {
        display_loading.push(camera.id);
      }
      var l = document.createElement("div");
      l.innerHTML = "loading...";
      l.setAttribute(
        "style",
        "color:" +
          col +
          "; position:absolute; left:30%; top:50%; margin-top:-" +
          size / 2 +
          "px;"
      );
      var ns = "http://www.w3.org/2000/svg";
      var svg = document.createElementNS(ns, "svg");
      svg.setAttribute("width", size + "px");
      svg.setAttribute("height", size + "px");
      svg.setAttribute("viewBox", "0 0 100 100");
      svg.setAttribute(
        "style",
        "position:absolute; top:50%; margin-top:-" + size / 2 + "px;"
      );
      l.appendChild(svg);
      c.appendChild(l);
      for (var i = 0; i < 12; i++) {
        var g = document.createElementNS(ns, "g");
        g.setAttribute("transform", "rotate(" + i * 30 + " 50 50)");
        svg.appendChild(g);
        var r = document.createElementNS(ns, "rect");
        r.setAttribute("x", "47");
        r.setAttribute("y", "23");
        r.setAttribute("width", "6");
        r.setAttribute("height", "14");
        r.setAttribute("fill", col);
        var a = document.createElementNS(ns, "animate");
        a.setAttribute("attributeName", "opacity");
        a.setAttribute("values", "1;0");
        a.setAttribute("keyTimes", "0;1");
        a.setAttribute("dur", "1s");
        a.setAttribute("begin", "" + (0 - (11 - i) / 12) + "s");
        a.setAttribute("repeatCount", "indefinite");
        r.appendChild(a);
        g.appendChild(r);
      }

      w.appendChild((this.name = document.createElement("div")));
      this.name.setAttribute("class", "camera_text camera_name");
      w.appendChild((this.time = document.createElement("div")));
      this.time.setAttribute("class", "camera_text camera_time");
      w.appendChild((this.zoom = document.createElement("button")));
      this.zoom.setAttribute("class", "camera_button camera_zoomin");
      w.appendChild((this.close = document.createElement("button")));
      this.close.setAttribute("class", "camera_button camera_close");

      var b;
      w.appendChild((b = this.time_frst = document.createElement("button")));
      b.setAttribute("class", "camera_time_button");
      b.innerHTML = "|＜";
      b.style.left = "144px";
      b.style.display = "none";
      w.appendChild((b = this.time_prev = document.createElement("button")));
      b.setAttribute("class", "camera_time_button");
      b.innerHTML = "＜";
      b.style.left = "184px";
      b.style.display = "none";
      w.appendChild((b = this.time_play = document.createElement("button")));
      b.setAttribute("class", "camera_time_button");
      b.innerHTML = "▶";
      b.style.left = "224px";
      b.style.display = "none";
      w.appendChild((b = this.time_next = document.createElement("button")));
      b.setAttribute("class", "camera_time_button");
      b.innerHTML = "＞";
      b.style.left = "264px";
      b.style.display = "none";
      w.appendChild((b = this.time_last = document.createElement("button")));
      b.setAttribute("class", "camera_time_button");
      b.innerHTML = "＞|";
      b.style.left = "304px";
      b.style.display = "none";

      w.appendChild(c);

      if (this.conf && this.conf.Attributes && this.conf.Attributes.expire) {
        w.appendChild((this.expire = document.createElement("div")));
        this.expire.setAttribute("class", "expire");
        if (this.conf.Attributes.expire.style) {
          for (var key in this.conf.Attributes.expire.style) {
            if (this.conf.Attributes.expire.style.hasOwnProperty(key)) {
              this.expire.style[key] = this.conf.Attributes.expire.style[key];
            }
          }
        }
      }

      this.setImage = function (index) {
        camera = this.camera;
        c = this.canvas;
        var name = camera[camera.name];
        if (this.name.innerHTML != name) {
          this.name.innerHTML = name;
        }
        this.index = index;
        if (camera.image_list.length) {
          var l = display_loading.indexOf(camera.id);
          if (l >= 0) {
            display_loading.splice(l, 1);
          }
          if (index < 0) {
            index = 0;
          }
          if (index >= camera.image_list.length) {
            index = camera.image_list.length - 1;
          }
          var target = camera.image_list[index];
          if (this.current_image != target.image) {
            c.innerHTML = "";
            if (target.image) {
              c.width = target.image.width || 600;
              c.height = target.image.height || 480;
              target.image.style.width = "100%";
              target.image.style.height = "100%";
              target.image.style["pointer-events"] = "none";
              c.appendChild(target.image);
            }
            this.current_image = target.image;
          }
          if (self.tooltip && target.valid) {
            var t = epoch.diff(target.dt) * 1000;
            if (t < time - conf.image_time_range * 1000) {
              c.innerHTML = "";
              this.current_image = null;
              debug({ info: "expired image " + name + ":" + target.time });
            }
          }

          var time_text;
          var date_format =
            layer_draw_conf && layer_draw_conf.Attributes.date_format;
          if ( date_format ) {
              var u_year = 0, u_mon = 0, u_day = 0, u_hour = 0, u_min = 0, u_sec = 0;
            if ( target.time && target.time.length >= 10 ) {
              u_year = parseInt(target.time.substr(0,4));
              u_mon = parseInt(target.time.substr(4,2));
              u_day = parseInt(target.time.substr(6,2));
              u_hour = parseInt(target.time.substr(8,2));
              u_min = parseInt(target.time.substr(10,2));
            }
            if ( target.time.length >= 12 )
              u_sec = parseInt(target.time.substr(12,2));
            time_text = WRAP.Geo.formatTime(date_format, u_year, u_mon, u_day, u_hour, u_min, u_sec);
          }
          else {
            var jst = WRAP.DH._timeString(WRAP.DH._setTime(WRAP.DH._time(target.time),9*3600));
            var day = Number(jst.substr(6,2));
            var hour = Number(jst.substr(9,2));
            var min = Number(jst.substr(11,2));
            time_text = ""+day+"日 "+hour+"時 "+min+"分";
          }
          if (this.time.innerHTML != time_text) this.time.innerHTML = time_text;

          self.time_frst.disabled = index == camera.image_list.length - 1;
          self.time_prev.disabled = index == camera.image_list.length - 1;
          self.time_play.disabled = camera.image_list.length <= 1;
          self.time_next.disabled = index == 0;
          self.time_last.disabled = index == 0;

          if (index == 0) {
            self.setExpire();
          }
        } else {
          this.time.innerHTML = "--";
          self.time_frst.disabled = true;
          self.time_prev.disabled = true;
          self.time_play.disabled = true;
          self.time_next.disabled = true;
          self.time_last.disabled = true;
          var l = display_loading.indexOf(camera.id);
          if (l < 0) {
            var c = this.canvas;
            c.innerHTML = "";
            var l = document.createElement("div");
            l.setAttribute(
              "style",
              "color:#555; position:absolute; top:50%; transform:translate(50%,-50%); width:100%;"
            );
            var m = document.createElement("div");
            m.innerHTML =
              (this.conf &&
                this.conf.Attributes &&
                this.conf.Attributes.unavailable_message) ||
              "unavailable";
            m.setAttribute(
              "style",
              "color:#555; position:absolute; transform:translate(-50%,-1em);"
            );
            l.appendChild(m);
            c.appendChild(l);
          }
        }
      };

      this.close.onclick = function () {
        self.hide();
      };

      this.zoom.onclick = function () {
        self.smooth = true;
        if (self.small) {
          update("WindowMaximize", self.camera.id);
          self.small = false;
          self.set();
        } else {
          update("WindowMinimize", self.camera.id);
          self.small = true;
          self.set();
        }
      };

      this.setAnimation = function (enabled) {
        if (self.animating != enabled) {
          self.animating = enabled;
          update(enabled ? "AnimationStart" : "AnimationEnd", self.camera.id);
        }
        return self.animating;
      };

      this.animate = function () {
        if (!self.animating) {
          self.time_play.innerHTML = "▶";
          return;
        }
        self.time_play.innerHTML = "■";
        var n = self.index - 1;
        if (n < 0) n = self.camera.image_list.length - 1;
        self.setImage(n);
        setTimeout(function () {
          self.animate();
        }, 500);
      };

      this.time_frst.onclick = function () {
        self.setImage(self.camera.image_list.length - 1);
      };
      this.time_prev.onclick = function () {
        self.setImage(self.index + 1);
      };
      this.time_play.onclick = function () {
        if (self.setAnimation(!self.animating)) {
          self.animate();
        }
      };
      this.time_next.onclick = function () {
        self.setImage(self.index - 1);
      };
      this.time_last.onclick = function () {
        self.setImage(0);
      };

      w.addEventListener("mousedown", function (evt) {
        dragging = this;
        drag_x = w.style.left.replace(/px/, "");
        drag_y = w.style.top.replace(/px/, "");
        offset_x = evt.clientX - drag_x;
        offset_y = evt.clientY - drag_y;
        activateCameraWindow(dragging.controller);
      });
      w.addEventListener("mouseup", function () {
        dragging = false;
      });
      w.addEventListener("touchstart", function (evt) {
        if (evt.touches && evt.touches.length == 1) {
          dragging = this;
          drag_x = w.style.left.replace(/px/, "");
          drag_y = w.style.top.replace(/px/, "");
          offset_x = evt.touches[0].pageX - drag_x;
          offset_y = evt.touches[0].pageY - drag_y;
          activateCameraWindow(dragging.controller);
        }
      });
      w.addEventListener("touchend", function () {
        dragging = false;
      });

      this.set = function () {
        var c = self.smooth ? "smooth_tran " : "";
        c += "live_camera";
        c += self.small ? " small_window" : " middle_window";
        if (!this.tooltip && this == current_camera) {
          c += " current_window";
        }
        self.window.setAttribute("class", c);

        c = self.smooth ? "smooth_tran " : "";
        c += self.small ? " image_s" : " image_m";
        self.canvas.setAttribute("class", c);

        self.zoom.setAttribute(
          "class",
          self.small
            ? "camera_button camera_zoomin"
            : "camera_button camera_zoomout"
        );
        self.time_frst.style.display = self.small ? "none" : "block";
        self.time_prev.style.display = self.small ? "none" : "block";
        self.time_play.style.display = self.small ? "none" : "block";
        self.time_next.style.display = self.small ? "none" : "block";
        self.time_last.style.display = self.small ? "none" : "block";

        self.zoom.style.display = self.tooltip ? "none" : "block";
        self.close.style.display = self.tooltip ? "none" : "block";

        if (self.small || !self.visible) {
          self.setAnimation(false);
        }
        if (self.small) {
          self.setImage(0);
        }
        if (self.smooth) {
          setTimeout(function () {
            self.smooth = false;
            self.set();
          }, 250);
        }
      };

      this.show = function (lat, lon) {
        self.set();
        if (!self.visible) {
          update("WindowOpen", self.camera.id);
        }
        self.visible = true;
        self.window.point = new WRAP.Geo.Point(lat, lon);
        var sp = WRAP.Geo.getScreenPoint(this.window.point);
        self.ox = camera_ox;
        self.oy = camera_oy;
        if (map_size) {
          if (sp.x + camera_sw + camera_ox > map_size.width) {
            self.ox = -camera_sw - camera_ox;
          }
          if (sp.y + camera_sh + camera_header + camera_oy > map_size.height) {
            self.oy = -camera_sh - camera_header - camera_oy;
          }
        }
        sp.x += self.ox;
        sp.y += self.oy;
        self.window.style.top = "" + sp.y + "px";
        self.window.style.left = "" + sp.x + "px";
        self.window.style.display = "block";
        self.updateImageStatus();
      };

      this.hide = function () {
        self.window.style.display = "none";
        if (self.visible) update("WindowClose", self.camera.id);
        self.visible = false;
        self.small = true;
        self.setAnimation(false);
        self.setImage(0);
        self.updateImageStatus();
      };

      this.suspend = function () {
        var display = "none";
        if (self.window.style.display != display) {
          self.window.style.display = display;
          self.setImage(0);
          update("WindowClose", self.camera.id);
        }
      };

      this.resume = function () {
        var display = self.visible ? "block" : "none";
        if (self.window.style.display != display) {
          self.window.style.display = display;
          update(display ? "WindowOpen" : "WindowClose", self.camera.id);
        }
      };

      this.updateImageStatus = function () {
        var image_in_map = false;
        if (this.window.style.display == "block") {
          var x = parseFloat(self.window.style.left.replace("px", ""));
          var y = parseFloat(self.window.style.top.replace("px", ""));
          y += camera_header;
          var sx = x + self.canvas.clientLeft;
          var sy = y + self.canvas.clientTop;
          var ex = sx + self.canvas.clientWidth;
          var ey = sy + self.canvas.clientHeight;
          image_in_map =
            0 < ex && sx < map_size.width && 0 < ey && sy < map_size.height;
        }
        if (!self.last_image_in_map == image_in_map) {
          // self.last_image_in_mapは undefined、falseまたはtrue
          self.last_image_in_map = image_in_map;
          update(
            self.last_image_in_map ? "WindowActive" : "WindowInActive",
            self.camera.id
          );
        }
      };

      this.setExpire = function () {
        if (
          self.conf &&
          self.conf.Attributes &&
          self.conf.Attributes.expire &&
          self.camera &&
          self.camera.image_list &&
          self.camera.image_list[0]
        ) {
          var now = WRAP.Core.currentTime();
          var latestTime = new WRAP.Core.DateTime(
            self.camera.image_list[0].time
          );
          var diff = latestTime.diff(now);
          var threshold = self.conf.Attributes.expire.threshold || 3600;
          var expireText;

          if (diff > threshold) {
            self.name.classList.add("short");
            self.expire.style.display = "block";
            expireText =
              self.conf.Attributes.expire.text ||
              "Not updated for over an hour";
          } else {
            self.name.classList.remove("short");
            self.expire.style.display = "none";
            expireText = "";
          }
          self.expire.innerHTML = expireText;
        }
      };

      base.appendChild(w);
      this.setImage(0);
    }

    function LiveCameraThumbnail(camera, layer_conf) {
      var self = this;
      this.camera = camera;
      this.conf = layer_conf;

      var l = display_loading.indexOf(camera.id);
      if (l < 0) {
        display_loading.push(camera.id);
      }

      var w = (this.icon = document.createElement("div"));
      w.controller = this;
      w.setAttribute("class", "live_camera_thumbnail");

      w.onclick = function () {
        touchHandler(self.layer, self.feature);
      };

      var thumbnail_icon = layer_conf.Attributes.thumbnail_icon;
      var icon_w = thumbnail_icon.width || 36;
      var icon_h = thumbnail_icon.height || 36;
      var round = thumbnail_icon.round_corner || 0;
      w.ox = -icon_w / 2;
      w.oy = -icon_h / 2;
      w.style.width = icon_w + "px";
      w.style.height = icon_h + "px";
      w.style.borderRadius = round + "px";
      w.point = new WRAP.Geo.Point(camera.lat, camera.lon);
      var sp = WRAP.Geo.getScreenPoint(w.point);
      sp.x += w.ox;
      sp.y += w.oy;
      w.style.left = sp.x + "px";
      w.style.top = sp.y + "px";

      var c = (this.canvas = document.createElement("canvas"));
      c.style.borderRadius = round + "px";
      var ctx = (this.canvas.ctx = c.getContext("2d"));
      c.width = icon_w;
      c.height = icon_h;
      ctx.fillStyle = "transparent";
      ctx.fillRect(0, 0, c.width, c.height);

      w.appendChild(c);
      base.appendChild(w);

      this.updateImage = function () {
        if (this.camera.image_list.length) {
          var c = this.canvas;
          c.ctx.fillRect(0, 0, c.width, c.height);
          c.ctx.drawImage(
            this.camera.image_list[0].image,
            0,
            0,
            c.width,
            c.height
          );
        }
      };
    }

    this.init = function (map) {
      camera_window = [];
      interaction = map;
      base = interaction.block;

      interaction.addEventHandler("mouseover", mouseOverHandler);
      interaction.addEventHandler("mouseout", mouseOutHandler);
      interaction.addEventHandler("touch", touchHandler);
      interaction.addEventHandler("boundsChange", boundsChangeHandler);
      interaction.addEventHandler("visibilityChange", visibilityChangeHandler);
      interaction.addEventHandler("mousemove", mouseMoveHandler);

      requestAnimationFrame(main_loop);
    };

    this.clearWindow = function () {
      if (base) {
        for (var i = 0; i < camera_window.length; i++) {
          var cw = camera_window[i];
          base.removeChild(cw.window);
        }
      }
      camera_window = [];
    };

    this.clearThumbnail = function () {
      for (var i = 0; i < camera_thumbnail.length; i++) {
        var ct = camera_thumbnail[i];
        ct.camera.icon_visible = undefined;
        base && base.removeChild(ct.icon);
      }
      camera_thumbnail = [];
    };

    this.clear = function () {
      if (interaction) {
        interaction.removeEventHandler("mouseover", mouseOverHandler);
        interaction.removeEventHandler("mouseout", mouseOutHandler);
        interaction.removeEventHandler("touch", touchHandler);
        interaction.removeEventHandler("boundsChange", boundsChangeHandler);
        interaction.removeEventHandler(
          "visibilityChange",
          visibilityChangeHandler
        );
        interaction.removeEventHandler("mousemove", mouseMoveHandler);
      }
      this.clearWindow();
      this.clearThumbnail();
    };

    this.updateImage = function (id) {
      var ct;
      if ((ct = findCameraThumbnail(id))) {
        ct.updateImage();
      }
      var cw;
      if (!(cw = findCameraWindow(id)) || !cw.visible) {
        return;
      }
      cw.setImage(cw.index);
    };

    this.clearImage = function (id) {
      var cw;
      if (!(cw = findCameraWindow(id)) || !cw.visible) {
        return;
      }
      cw.canvas.innerHTML = "";
    };

    this.updateCamera = function (camera) {
      var cw;
      if (!(cw = findCameraWindow(camera.id))) {
        return;
      }
      cw.camera = camera;
    };

    this.setStyle = function (conf) {
      var s = conf && conf.Attributes;
      if (s && !style_initialized) {
        style_initialized = true;
        if (s.zoom_in_button) {
          zoom_in_button = s.zoom_in_button;
        }
        if (s.zoom_out_button) {
          zoom_out_button = s.zoom_out_button;
        }
        if (s.close_button) {
          close_button = s.close_button;
        }
        interaction.setStyle(style());
      }
    };

    this.updateCameraThumbnail = function () {
      updateCameraThumbnail();
    };

    this.showThumbnail = function (camera, conf, layer, feature) {
      var ct;
      if (!(ct = findCameraThumbnail(camera.id))) {
        ct = new LiveCameraThumbnail(camera, conf);
        camera_thumbnail.push(ct);
      }
      ct.camera = camera;
      ct.icon.style.display = "block";
      ct.layer = layer;
      ct.feature = feature;
      ct.updateImage();
    };

    this.hideThumbnail = function (camera) {
      var ct;
      if (!(ct = findCameraThumbnail(camera.id))) {
        return;
      }
      ct.icon.style.display = "none";
    };

    // TODO yukuzu
    Object.defineProperties(this, {
      currentCamera: {
        get() {
          return () => current_camera;
        },
      },
      showCameraWindow: {
        get() {
          return showCameraWindow;
        },
      },
    });
  };

  var interaction;
  WRAP.Overlay.init(function (map) {
    interaction = map;
    if (overlay) {
      overlay.init(interaction);
    }
  });

  function ready(data, layer) {
    if (!controller && !controller_waiting) {
      controller_waiting = true;
      data.initialized(function () {
        controller = data;
        controller_waiting = false;
        debug({
          info: "livecamera overlay initialize : " + data.controller_conf.Name,
        });
        if (data.controller_conf.Name == "Bundle") {
          var reference = data.source["data"].conf.reference;
          if (reference) {
            for (var i = 0; i < reference.length; i++) {
              var conf = WRAP.DH.conf_path + "/" + reference[i] + ".json";
              WRAP.Data.getJSON(conf, function (c) {
                initOverlay(data, c.Controller);
              });
            }
          }
        }
        initOverlay(data, data.controller_conf);
        layer.invalidate();
      });
    }
    return controller;
  }

  function initOverlay(data, controller_conf) {
    override(controller_conf);
    if (overlay) {
      return;
    }
    overlay = new Overlay(data); // オーバーレイ管理
    data.updated("data", updateCamera);
    if (interaction) {
      overlay.init(interaction);
    }
  }

  this.getOverlay = function() {
    return overlay;
  }

  function __unused() {} // warning suppress

  // ステータス取得
  this.getStatus = function () {
    return status;
  };

  // イベント監視
  this.inspect = function (cb) {
    inspector = cb;
  };

  // TODO yukuzu
  Object.defineProperties(this, {
    camera_info: {
      get: () => camera_info,
    },
    camera_window: {
      get: () => camera_window,
    },
    update: {
      get: () => update,
    },
    currentCamera: {
      get: () => overlay.currentCamera,
    },
    showCameraWindow: {
      get: () => overlay.showCameraWindow,
    },
  });
};
/* eslint-enable */
